import { Box, CircularProgress, Typography } from '@mui/material'
import { Navigate, Outlet, Route, Routes, useLocation, useParams } from 'react-router-dom'
import EdumiamLayout from '../components/iperia/EdumiamLayout'
import { IperiaStatusProvider, useIperiaStatus } from '../hooks/useIperiaStatus'
import Verification from '../pages/iperia/Verification'
import VerificationAddress from '../pages/iperia/VerificationAddress'
import VerificationFormation from '../pages/iperia/VerificationFormation'
import VerificationSummary from '../pages/iperia/VerificationSummary'
import Documents from '../pages/iperia/Documents'
import ParentEmployeurInfo from '../pages/iperia/ParentEmployeurInfo'
import ParentEmployeurAddress from '../pages/iperia/ParentEmployeurAddress'
import Nir from '../pages/iperia/Nir'
import Signature from '../pages/iperia/Signature'
import Success from '../pages/iperia/Success'
import {
  canAccessStep,
  getDefaultRouteForStatus,
  getStepFromPath,
} from '../utils/iperiaNavigation'

function IperiaLoading() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
      <CircularProgress />
    </Box>
  )
}

function IperiaStatusError({ message }: { message: string }) {
  return (
    <Box sx={{ p: 4 }}>
      <Typography color="error">{message}</Typography>
    </Box>
  )
}

function IperiaIndexRedirect() {
  const { global_id: globalId } = useParams<{ global_id: string }>()
  const { status, loading, error } = useIperiaStatus()

  if (loading) return <IperiaLoading />
  if (error || !status || !globalId) {
    return <IperiaStatusError message="Impossible de charger votre dossier." />
  }
  return <Navigate to={`/iperia/${globalId}/${getDefaultRouteForStatus(status)}`} replace />
}

function IperiaNavigationGate() {
  const { global_id: globalId } = useParams<{ global_id: string }>()
  const { status, loading, error } = useIperiaStatus()
  const location = useLocation()

  if (loading) return <IperiaLoading />
  if (error || !status || !globalId) {
    return <IperiaStatusError message="Impossible de charger votre dossier." />
  }

  const currentStep = getStepFromPath(location.pathname)
  if (currentStep && !canAccessStep(status, currentStep)) {
    return <Navigate to={`/iperia/${globalId}/${getDefaultRouteForStatus(status)}`} replace />
  }

  return <Outlet />
}

export default function IperiaRoutes() {
  return (
    <IperiaStatusProvider>
      <Routes>
        <Route element={<EdumiamLayout />}>
          <Route element={<IperiaNavigationGate />}>
            <Route path="verification" element={<Verification />} />
            <Route path="verification/adresse" element={<VerificationAddress />} />
            <Route path="verification/formation" element={<VerificationFormation />} />
            <Route path="verification/recapitulatif" element={<VerificationSummary />} />
            <Route path="documents" element={<Documents />} />
            <Route path="parent-employeur" element={<ParentEmployeurInfo />} />
            <Route path="parent-employeur/adresse" element={<ParentEmployeurAddress />} />
            <Route path="nir" element={<Nir />} />
            <Route path="signature" element={<Signature />} />
            <Route path="success" element={<Success />} />
            <Route index element={<IperiaIndexRedirect />} />
            <Route path="*" element={<IperiaIndexRedirect />} />
          </Route>
        </Route>
      </Routes>
    </IperiaStatusProvider>
  )
}
